/* Amoveia product buy-box: gallery, packs, subscribe, AJAX add-to-cart, variant URL, sticky, delivery estimate */
(function(){
  var root = document.getElementById('buy-form');
  if(!root) return;
  var section = root.closest('.section');
  var idInput = root.querySelector('[data-variant-id]');
  var planInput = root.querySelector('[data-selling-plan-input]');
  var qtyInput = root.querySelector('[data-qty-input]');
  var priceEl = section.querySelector('[data-product-price]');
  var stickyPrice = document.querySelector('[data-sticky-price]');
  var atcBtn = root.querySelector('[data-atc]');
  var atcText = root.querySelector('[data-atc-text]');
  var soldOutTxt = (window.AmoveiaSettings&&AmoveiaSettings.strings&&AmoveiaSettings.strings.soldOut)||'Sold out';
  var addTxt = (window.AmoveiaSettings&&AmoveiaSettings.strings&&AmoveiaSettings.strings.addToCart)||'Add to cart';
  var planSelEl = section.querySelector('[data-selling-plan-select]');
  var planData = {};
  try{ var _pd = section.querySelector('[data-plan-prices]'); if(_pd) planData = JSON.parse(_pd.textContent); }catch(e){}
  var cur = { id:null, price:null, compare:null, save:null, avail:true };
  var mode = 'onetime';
  // keep the Subscribe / One-time rows showing the selected pack's price
  // (subscribe = discounted amount struck against the one-time price)
  function syncRowPrices(){
    if(!cur.price) return;
    var oneEl = section.querySelector('[data-one-price]');
    if(oneEl) oneEl.textContent = cur.price;
    var subEl = section.querySelector('[data-sub-price]');
    if(subEl){
      var pid = planSelEl ? planSelEl.value : (planInput && planInput.value);
      var m = planData[cur.id] && planData[cur.id][pid];
      if(m){ subEl.innerHTML = '<span class="buy-option__now">'+m.p+'</span><s class="buy-option__was">'+cur.price+'</s>'; }
      else { subEl.textContent = cur.price; }
    }
  }
  function renderPrice(){
    if(!priceEl || !cur.price) return;
    syncRowPrices();
    if(mode==='subscribe'){
      var pid = planSelEl ? planSelEl.value : (planInput && planInput.value);
      var m = planData[cur.id] && planData[cur.id][pid];
      if(m){
        priceEl.innerHTML = '<div class="price price--on-sale"><span class="price__sale">'+m.p+'</span><s class="price__compare">'+cur.price+'</s>'+(m.pct?'<span class="price__badge-save">Save '+m.pct+'%</span>':'')+'</div>';
        if(stickyPrice) stickyPrice.textContent = m.p;
        return;
      }
    }
    if(cur.compare){
      priceEl.innerHTML = '<div class="price price--on-sale"><span class="price__sale">'+cur.price+'</span><s class="price__compare">'+cur.compare+'</s>'+(cur.save?'<span class="price__badge-save">Save '+cur.save+'%</span>':'')+'</div>';
    } else {
      priceEl.innerHTML = '<div class="price"><span class="price__regular">'+cur.price+'</span></div>';
    }
    if(stickyPrice) stickyPrice.textContent = cur.price;
  }
  function setVariant(id, priceStr, available, compareStr, savePct){
    cur.id = id;
    if(priceStr){ cur.price = priceStr; cur.compare = compareStr || null; cur.save = savePct || null; }
    cur.avail = available;
    if(idInput) idInput.value = id;
    if(atcBtn){ atcBtn.disabled = available===false; if(atcText) atcText.textContent = available===false ? soldOutTxt : addTxt; }
    // reflect the chosen variant in the URL (?variant=ID) so the exact pack link is shareable / ad-ready
    if(id && window.history && history.replaceState){
      try{ var u=new URL(window.location.href); u.searchParams.set('variant', id); history.replaceState({}, '', u.toString()); }catch(e){}
    }
    renderPrice();
  }
  // pack cards (mouse + keyboard — they are role="radio" tabindex="0")
  var packs = Array.prototype.slice.call(section.querySelectorAll('[data-pack]'));
  function selectPack(opt){
    packs.forEach(function(o){ o.classList.remove('is-selected'); if(o.hasAttribute('aria-checked')) o.setAttribute('aria-checked','false'); });
    opt.classList.add('is-selected');
    if(opt.hasAttribute('aria-checked')) opt.setAttribute('aria-checked','true');
    var r = opt.querySelector('input'); if(r) r.checked = true;
    if(qtyInput) qtyInput.value = opt.getAttribute('data-qty') || '1';
    setVariant(opt.getAttribute('data-variant-id'), opt.getAttribute('data-price-formatted'), opt.getAttribute('data-available')!=='false', opt.getAttribute('data-compare-formatted'), opt.getAttribute('data-save-pct'));
    // swap the main gallery image to the selected variant's image (Elixir-style)
    var pimg = opt.getAttribute('data-pack-image');
    if(pimg){ var gmain = section.querySelector('[data-gallery-main] img'); if(gmain) gmain.src = pimg; }
    // Subscribe = 1 bottle per delivery (cadence matches 1 bottle). Picking a multi-bottle pack switches to one-time.
    if(mode==='subscribe' && packs.length && opt!==packs[0]){ var oneOpt = section.querySelector('[data-purchase="onetime"]'); if(oneOpt) selectPurchase(oneOpt); }
  }
  packs.forEach(function(opt, idx){
    opt.addEventListener('click', function(){ selectPack(opt); });
    opt.addEventListener('keydown', function(e){
      if(e.key===' '||e.key==='Enter'){ e.preventDefault(); selectPack(opt); }
      else if(e.key==='ArrowDown'||e.key==='ArrowRight'){ e.preventDefault(); var n=packs[(idx+1)%packs.length]; selectPack(n); n.focus(); }
      else if(e.key==='ArrowUp'||e.key==='ArrowLeft'){ e.preventDefault(); var p=packs[(idx-1+packs.length)%packs.length]; selectPack(p); p.focus(); }
    });
  });
  // variant select fallback
  var vs = section.querySelector('[data-variant-select]');
  if(vs){ vs.addEventListener('change', function(){ var o=vs.options[vs.selectedIndex]; setVariant(vs.value, o.getAttribute('data-price-formatted'), !o.disabled); }); }
  // subscribe toggle
  var subBody = section.querySelector('[data-subscribe-body]');
  function selectPurchase(opt){
    section.querySelectorAll('[data-purchase]').forEach(function(o){o.classList.remove('is-selected'); if(o.hasAttribute('aria-checked')) o.setAttribute('aria-checked','false');});
    opt.classList.add('is-selected'); if(opt.hasAttribute('aria-checked')) opt.setAttribute('aria-checked','true');
    var isSub = opt.getAttribute('data-purchase')==='subscribe';
    // Subscribe always ships 1 bottle per delivery — force the Buy 1 pack
    if(isSub && packs.length && !packs[0].classList.contains('is-selected')){ mode='subscribe'; selectPack(packs[0]); }
    var sel = section.querySelector('[data-selling-plan-select]');
    if(subBody) subBody.hidden = !isSub;
    if(isSub){ if(planInput && sel){ planInput.value = sel.value; planInput.disabled=false; } }
    else { if(planInput){ planInput.value=''; planInput.disabled=true; } }
    mode = isSub ? 'subscribe' : 'onetime';
    renderPrice();
  }
  section.querySelectorAll('[data-purchase]').forEach(function(opt){
    opt.addEventListener('click', function(){ selectPurchase(opt); });
    opt.addEventListener('keydown', function(e){ if(e.key===' '||e.key==='Enter'){ e.preventDefault(); selectPurchase(opt); } });
  });
  var planSel = planSelEl;
  if(planSel){ planSel.addEventListener('change', function(){ if(planInput){ planInput.value=planSel.value; } renderPrice(); }); }
  // coupon promotes Subscribe: clicking it selects the Subscribe option
  var couponBtn = section.querySelector('[data-select-subscribe]');
  if(couponBtn){
    couponBtn.addEventListener('click', function(){
      var sub = section.querySelector('[data-purchase="subscribe"]');
      if(sub){ sub.click(); if(sub.scrollIntoView){ try{ sub.scrollIntoView({block:'center',behavior:'smooth'}); }catch(e){} } }
    });
  }
  // init: reflect the default-selected pack + purchase mode (subscribe-first) so the price shows the subscription amount on load
  var _ip = section.querySelector('[data-pack].is-selected') || section.querySelector('[data-pack]');
  if(_ip){ cur = {id:_ip.getAttribute('data-variant-id'), price:_ip.getAttribute('data-price-formatted'), compare:_ip.getAttribute('data-compare-formatted'), save:_ip.getAttribute('data-save-pct'), avail:_ip.getAttribute('data-available')!=='false'}; if(idInput&&cur.id) idInput.value=cur.id; }
  var _sp = section.querySelector('[data-purchase].is-selected');
  mode = (_sp && _sp.getAttribute('data-purchase')==='subscribe') ? 'subscribe' : 'onetime';
  // a multi-bottle pack pre-selected (e.g. ?variant= link) can't be a subscription → start in one-time mode
  if(mode==='subscribe' && _ip && packs.length && _ip!==packs[0]){ var _one = section.querySelector('[data-purchase="onetime"]'); if(_one) selectPurchase(_one); }
  renderPrice();
  // gallery
  var thumbs = Array.prototype.slice.call(section.querySelectorAll('[data-gallery-thumb]'));
  function showThumb(t){
    if(!t) return;
    var main = section.querySelector('[data-gallery-main] img'); var full=t.getAttribute('data-full');
    if(main&&full) main.src=full;
    thumbs.forEach(function(x){x.classList.remove('is-active');});
    t.classList.add('is-active');
    if(t.scrollIntoView){ try{ t.scrollIntoView({inline:'nearest',block:'nearest',behavior:'smooth'}); }catch(e){} }
  }
  thumbs.forEach(function(t){ t.addEventListener('click', function(){ showThumb(t); }); });
  var galMain = section.querySelector('[data-gallery-main]');
  // step through photos (wraps around), shared by arrows + keyboard
  function stepGallery(dir){
    if(thumbs.length < 2) return;
    var i = thumbs.findIndex(function(x){ return x.classList.contains('is-active'); }); if(i<0) i=0;
    var ni = (i + dir + thumbs.length) % thumbs.length;
    showThumb(thumbs[ni]);
  }
  var prevBtn = section.querySelector('[data-gallery-prev]');
  var nextBtn = section.querySelector('[data-gallery-next]');
  function stopHint(){ if(galMain) galMain.classList.remove('is-hinting'); }
  if(prevBtn) prevBtn.addEventListener('click', function(){ stopHint(); stepGallery(-1); });
  if(nextBtn) nextBtn.addEventListener('click', function(){ stopHint(); stepGallery(1); });
  // keyboard arrows when the gallery is focused/hovered
  if(galMain && thumbs.length > 1){
    galMain.setAttribute('tabindex','0');
    galMain.addEventListener('keydown', function(e){
      if(e.key==='ArrowLeft'){ e.preventDefault(); stopHint(); stepGallery(-1); }
      else if(e.key==='ArrowRight'){ e.preventDefault(); stopHint(); stepGallery(1); }
    });
  }
  // swipe the main image to move between photos
  if(galMain && thumbs.length > 1){
    var sx=0, sy=0, tracking=false;
    galMain.addEventListener('touchstart', function(e){ var t=e.changedTouches[0]; sx=t.clientX; sy=t.clientY; tracking=true; }, {passive:true});
    galMain.addEventListener('touchend', function(e){
      if(!tracking) return; tracking=false;
      var t=e.changedTouches[0], dx=t.clientX-sx, dy=t.clientY-sy;
      if(Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return; // ignore taps / vertical scrolls
      stopHint();
      stepGallery(dx < 0 ? 1 : -1);
    }, {passive:true});
    // "nhảy nhảy" attention hint: pulse the arrows once when the gallery scrolls into view
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(!reduce){
      var hinted=false;
      var fireHint=function(){ if(hinted) return; hinted=true; galMain.classList.add('is-hinting'); setTimeout(stopHint, 2600); };
      if('IntersectionObserver' in window){
        var io=new IntersectionObserver(function(en){ en.forEach(function(x){ if(x.isIntersecting){ fireHint(); io.disconnect(); } }); },{threshold:0.35});
        io.observe(galMain);
      } else { setTimeout(fireHint, 700); }
      galMain.addEventListener('mouseenter', stopHint);
    }
  }
  // AJAX add-to-cart → open the drawer. Falls back to a native form POST if the
  // cart JS hasn't loaded. (The sticky bar's visibility + button are owned by
  // theme.js initStickyATC, so nothing sticky is wired here — avoids double-submit.)
  root.addEventListener('submit', function(e){
    var C = window.AmoveiaCart;
    if(!C || !C.add) return; // let the native POST happen
    e.preventDefault();
    if(atcBtn && atcBtn.disabled) return;
    var idv = idInput ? idInput.value : null;
    if(!idv) return;
    var item = { id: idv, quantity: (qtyInput && parseInt(qtyInput.value,10)) || 1 };
    if(planInput && !planInput.disabled && planInput.value){ item.selling_plan = planInput.value; }
    if(atcBtn) atcBtn.classList.add('is-loading');
    C.add({ items: [item] })
      .then(function(){ return C.refresh(true); })
      .then(function(){ if(C.toast) C.toast(C.addedText || 'Added to cart'); })
      .catch(function(err){ if(C.toast) C.toast((err && err.description) || 'Unavailable'); })
      .finally(function(){ if(atcBtn) atcBtn.classList.remove('is-loading'); });
  });
  // estimated delivery date range (business days)
  var de = section.querySelector('[data-delivery-estimate]');
  if(de){
    var mn = parseInt(de.getAttribute('data-min'),10)||3, mx = parseInt(de.getAttribute('data-max'),10)||7;
    function addBiz(n){ var d=new Date(), a=0; while(a<n){ d.setDate(d.getDate()+1); var g=d.getDay(); if(g!==0&&g!==6) a++; } return d; }
    var opt={month:'short',day:'numeric'};
    try{ de.textContent = addBiz(mn).toLocaleDateString('en-US',opt) + ' – ' + addBiz(mx).toLocaleDateString('en-US',opt); }catch(e){ de.textContent=''; }
  }
})();
